const initialState = {
    data: [],
  };
  
const przelewyUReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PRZELEWY_U':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default przelewyUReducer;